export const NETWORKGRAPH = "networkgraph";
export const MOREGRAPH = "more";

export const VISIBILITY = {
    public: "PUB",
    private: "PRIV",
    community: "COMM",
    hide: "HIDE",
};

export const VISIBILITY_MAP = {
    [VISIBILITY.community]: "Comunidad",
    [VISIBILITY.hide]: "Archivado",
    [VISIBILITY.public]: "Establecimiento",
    [VISIBILITY.private]: "Privado",
};

export const QUALIFICATION = {
    disapproved: "DISA",
    approved: "APPR",
    reDelivery: "REDE",
};

export const QUALIFICATION_LABEL = {
    DISA: "Desaprobado",
    APPR: "Aprobado",
    REDE: "Re entrega",
};

export const MAP_COLUMNS = {
    value: "Eje x (categoría)",
    group_by: "Eje y (subcategoría)",
    valuePie: "Categorizar por",
    datasetColumns: "Columnas Dataset",
    source: "Origen",
    target: "Destino",
    lat: "Latitud",
    lon: "Longitud",
    name: "Nombre",
};

export const MAP_GRAPHS = {
    dataTable: "Tabla de datos",
    column: "Columnas agrupadas",
    line: "Líneas agrupadas",
    pie: "Torta",
    bubble: "Burbujas",
    dispersion: "Dispersión",
    map: "Mapa",
    social_user_comments: "Grafo de interacción entre usuarios",
    social_word_frequency: "Grafo de coocurrencias de palabras",
    static_network: "Grafo",
    word_cloud: "Nube de palabras",
};

export const ROLE_MAP = {
    admin: "Administrador",
    teacher: "Profesor",
    student: "Estudiante",
    superadmin: "Superadmin",
};

export const USER = "USER";
export const COURSE = "COUR";
export const QUESTION = "QUES";

export const PENDING_NOTIFICATION_MAP = {
    superadmin: [USER],
    admin: [COURSE, USER],
    teacher: [COURSE, QUESTION],
    student: [QUESTION],
};

export const DEFAULT_DATA_GRAPHER = {
    dataTable: {
        selected: false,
        columns: { value: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    column: {
        selected: false,
        columns: { value: [], group_by: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    line: {
        selected: false,
        columns: { value: [], group_by: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    pie: {
        selected: false,
        columns: { valuePie: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    bubble: {
        selected: false,
        columns: { value: [], group_by: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    dispersion: {
        selected: false,
        columns: { value: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    social_word_frequency: {
        selected: false,
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        dataSource: "dynamic",
        nodesId: [],
    },
    social_user_comments: {
        selected: false,
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        dataSource: "dynamic",
        nodesId: [],
    },
    map: {
        selected: false,
        columns: { lat: [], lon: [], name: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
    },
    static_network: {
        selected: false,
        columns: { source: [], target: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 1,
        dataSource: "static",
        metric: "normal",
    },
    word_cloud: {
        selected: false,
        columns: { value: [] },
        export: { image: null, offsetHeight: null, offsetWidth: null },
        comment: "",
        filterInclude: [],
        filterExclude: [],
        limitDrag: 2,
        dataSource: "static",
    },
};
